import debug from 'debug';
import plugin from '../../lib/vanilla-plugin';

const ELEMENT_SELECTOR = '[data-presubmit-check]';
const MODULE_NAME = 'presubmitCheck';
const log = debug(MODULE_NAME);

export function exec() {
	const elements = document.querySelectorAll(ELEMENT_SELECTOR);
	log('exec', elements);

	if (!elements) return false;

	System.import(
		/* webpackChunkName: "presubmit-check" */ './presubmit-check'
	).then((module) => {
		plugin(MODULE_NAME, module.default)();
	});
};



// WEBPACK FOOTER //
// ./client/src/core/modules/presubmit-check/index--split.js